import React from "react";
import PropTypes from "prop-types";
import DayPickerInput from "./DayPickerInput";

import {isMobile} from "../utils";


class DateInput extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
    };

    static defaultProps = {
        className: 'form-input',
        disabled: false,
        readOnly: false,
    };

    isMobile = isMobile();

    render() {
        const {id, name, value, onChange, className, placeholder, disabled, readOnly} = this.props;

        if (this.isMobile)
            return <input type="date" id={name} className={className} name={name} disabled={disabled} readOnly={readOnly}
                          value={value} placeholder={placeholder} onChange={onChange}
                          pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" />;
        else {
            const inputProps = {name, id: id || name, className, disabled, readOnly};
            return <DayPickerInput inputProps={inputProps} placeholder={placeholder} onChange={onChange} value={value}/>;
        }
    }
}

export default DateInput;